import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaError, CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { CaDatepickerComponent } from '@global-front-components/ui/datepicker';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CatalogoGeneralStoreService } from '../../services/store/catalogo-general-store.service';
import { FraccionamientoCatalogo, IdiomaCatalogo } from '../../model/catalogo.model';
import { CaSelectComponent } from '@global-front-components/ui/select';
import { Poliza, Pregunta, Riesgo } from '../../model/poliza.model';

@Component({
	selector: 'app-datos-adicionales',
	standalone: true,
	imports: [
		CommonModule,
		CaFormFieldComponent,
		CaDatepickerComponent,
		ReactiveFormsModule,
		CaSelectComponent,
		CaError,
		TranslateModule,
		CaLabel
	],
	templateUrl: './datos-adicionales.component.html',
	styleUrls: ['./datos-adicionales.component.scss']
})
export class DatosAdicionalesComponent implements OnInit {
	@Input() form: FormGroup;
	@Input() fraccionamientos!: FraccionamientoCatalogo[];
	@Input() poliza: Poliza<Riesgo> = {};

	constructor(private fb: FormBuilder) { }

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm(): void {
		if (!this.form) {
			this.form = this.fb.group({});
		}
		const codigoFraccionamiento =
			this.poliza?.codigoFraccionamiento ||
			this.getCodigoFraccionamientoPorDefecto();
		this.form.addControl('codFrac', this.fb.control(codigoFraccionamiento, [Validators.required]));
		// Si no viene, usamos la fecha actual
		const fechaEfectoISO = this.poliza?.fechaEfecto || new Date();
		const fechaEfecto = new Date(fechaEfectoISO).getTime();
		this.form.addControl('fEfecto', this.fb.control(fechaEfecto, [Validators.required]));
	}

	private getCodigoFraccionamientoPorDefecto(): string | undefined {
		if (!this.fraccionamientos || this.fraccionamientos.length === 0) return undefined;

		return this.fraccionamientos
			.map(f => f.codigoFraccionamiento ?? '')
			.filter(c => c !== '')
			.sort((a, b) => Number(a) - Number(b))[0];
	}
}
